<script lang="ts" setup>
import NavbarItem from '@/components/layout/NavbarMenuItem.vue';
import { INavbarItem } from '~/INavbarItem';

interface Props {
  dataTestid?: string;
  items?: INavbarItem[];
  level?: number;
}

const props = withDefaults(defineProps<Props>(), {
  dataTestid: 'navbar_menu',
  items: undefined,
  level: 1,
});

// Emits.
const emit = defineEmits(['click']);
</script>

<template>
  <ul
    v-if="props.items?.length"
    class="navbar-menu"
    :class="{
      [`navbar-menu--${props.level}`]: true,
      'is-submenu': props.level > 1,
    }"
    :data-testid="`${props.dataTestid}_${props.level}`"
  >
    <NavbarItem
      v-for="(item, index) in items"
      :key="index"
      :data-testid="`${props.dataTestid}_${item.route.name}`"
      :item="item"
      @click="emit('click', $event)"
    >
      <template
        #after
        v-if="item.route.children?.length > 0"
      >
        <NavbarMenu
          :data-testid="props.dataTestid"
          :items="item.route.children.map((route) => ({ route }))"
          :level="level + 1"
        />
      </template>
    </NavbarItem>
  </ul>
</template>

<style lang="scss">
.navbar-menu {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.navbar-menu-item > .navbar-menu {
  background: var(--drawer-color, var(--white));
  box-shadow: var(--layer-shadow-nav);
  cursor: pointer;
  flex-direction: column;
  left: 0;
  min-width: 100px;
  position: absolute;
  opacity: 0;
  top: calc(50%);
  transform: translate(0%, 0%);
  transition: all ease-in-out 300ms;
  visibility: hidden;
}

.navbar-menu-item.open > .navbar-menu {
  --drawer-color: var(--gray-lighten-5);
  opacity: 1;
  top: 100%;
  visibility: visible;
  min-width: 100%;
}

.drawer--opens-left + .navbar-menu {
  left: auto;
  right: 0;
  transform: translate(0%, 0%);
}
</style>
